import React from "react";

const Dashboard = () => {
  return (
    <React.Fragment>
      <div className="overflow-auto h-screen pb-24 pt-2 pr-2 pl-2 md:pt-0 md:pr-0 md:pl-0">
        <div className="flex flex-col flex-wrap sm:flex-row ">
          <div className="w-full ">
            <div className="mb-4 mx-0 sm:ml-4 xl:mr-4">
              <div className="shadow-lg rounded-2xl bg-white dark:bg-gray-700 w-full">
                <p className="font-bold text-4xl p-6 text-black dark:text-white">
                  Selamat Datang Di Aplikasi YPU
                </p>
                <p className="font-bold text-xl p-6 text-red-600 upper dark:text-white">
                  Harap buka dashboard di browser desktop karena di mobile
                  sidebar tidak akan muncul
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
